import { Contact } from "./contacts.model";
import { Sale, SaleForm } from "./sales.model";

export class Returned extends Sale {

    contact: Contact
        approved: boolean;


    constructor() {
        super();
        this.contact = new Contact();
    }

}

export class ReturnedForm extends SaleForm {

    contact: number
    approved: boolean;


    constructor() {
        super();
    }
}


